// @ts-strict-ignore
import { useState } from "react";

import { NoStyleAccordion } from "@aviary";
import { Ingredient } from "@clinic/shared/components/AggregatedIngredientList/Ingredient/Ingredient";
import type { AggregatedIngredient } from "@clinic/shared/components/IngredientTable/AggregatedIngredients.query";
import type { PlanIngredient } from "@shared/types/graphqlGenerated";

import * as styles from "./IngredientAccordion.styles";

interface Props {
  ingredientWithDosage: AggregatedIngredient | PlanIngredient;
  showProductIcon?: boolean;
  withIndent?: boolean;
}

const IngredientAccordion = ({ ingredientWithDosage, showProductIcon, withIndent }: Props) => {
  const [isAccordionOpen, setIsAccordionOpen] = useState(false);

  return (
    <div>
      <NoStyleAccordion
        chevronPosition="start"
        onChange={isOpen => setIsAccordionOpen(isOpen)}
        css={[styles.accordion, isAccordionOpen && styles.accordionOpen]}
        coreTriggerContent={
          <div css={styles.ingredientHeader}>
            <Ingredient
              key={ingredientWithDosage.ingredient.name}
              name={ingredientWithDosage.ingredient.name}
              amount={ingredientWithDosage.dosage}
              unit={ingredientWithDosage.dosageUnit}
              alternateAmount={ingredientWithDosage.alternativeDosage}
              alternateUnit={ingredientWithDosage.alternativeDosageUnit}
              productNames={ingredientWithDosage.productNames}
              productCount={ingredientWithDosage.productCount}
              showProductIcon={showProductIcon}
              withIndent={withIndent}
              isForAccordion
            />
          </div>
        }
      >
        {ingredientWithDosage?.childIngredients?.map(
          (childIngredient: AggregatedIngredient | PlanIngredient) => (
            <div css={styles.childIngredients} key={childIngredient.ingredient.id}>
              <Ingredient
                key={childIngredient.ingredient.id}
                name={childIngredient.ingredient.name}
                amount={childIngredient.dosage}
                unit={childIngredient.dosageUnit}
                alternateAmount={childIngredient.alternativeDosage}
                alternateUnit={childIngredient.alternativeDosageUnit}
                productNames={childIngredient.productNames}
                productCount={childIngredient.productCount}
                showProductIcon={showProductIcon}
                withIndent={withIndent}
                isForAccordionChild
              />
            </div>
          )
        )}
      </NoStyleAccordion>
    </div>
  );
};

export { IngredientAccordion };
